import { ChangeEvent, FormEvent, useCallback, useState } from "react";

import { useT } from "@/i18n";
import { Button, TextButton, TextField } from "@/ui";

type MaintenanceBypassFormProps = {
  /** Returns false when the code is wrong. */
  onSubmit: (code: string) => boolean;
};

export const MaintenanceBypassForm = ({ onSubmit }: MaintenanceBypassFormProps) => {
  const t = useT();
  const [isOpen, setIsOpen] = useState(false);
  const [code, setCode] = useState("");
  const [isInvalid, setIsInvalid] = useState(false);

  const open = useCallback(() => setIsOpen(true), []);

  const handleChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    setCode(event.target.value);
    setIsInvalid(false);
  }, []);

  const handleSubmit = useCallback(
    (event: FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      setIsInvalid(!onSubmit(code));
    },
    [code, onSubmit]
  );

  if (!isOpen) {
    return (
      <TextButton onPress={open} className="mt-6">
        {t("maintenance.components.notice.accessCodeLink")}
      </TextButton>
    );
  }

  return (
    <form
      onSubmit={handleSubmit}
      className="mt-6 flex w-full max-w-[320px] flex-col gap-3 text-left"
    >
      <TextField
        label={t("maintenance.components.notice.accessCodeLabel")}
        type="password"
        autoComplete="off"
        autoFocus
        isRequired={false}
        hideOptionalLabel
        value={code}
        onChange={handleChange}
        isInvalid={isInvalid}
        errorMessage={isInvalid ? t("maintenance.components.notice.accessCodeInvalid") : undefined}
      />
      <Button type="submit" isDisabled={!code.trim()}>
        {t("maintenance.components.notice.accessCodeSubmit")}
      </Button>
    </form>
  );
};
